import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M10.0699 2.87183C10.0699 2.87183 5.45989 10.3618 2.13989 10.8018C2.13989 10.8018 4.34989 16.5218 8.77989 17.4118L7.11989 20.6018C7.11989 20.6018 8.68989 23.0218 12.8399 24.3418C16.6699 25.5618 20.3999 24.6718 20.3999 24.6718L10.0699 2.87183Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M50.3598 2.87183C50.3598 2.87183 54.9698 10.3618 58.2898 10.8018C58.2898 10.8018 56.0798 16.5218 51.6498 17.4118L53.3098 20.6018C53.3098 20.6018 51.7398 23.0218 47.5898 24.3418C43.7598 25.5618 40.0298 24.6718 40.0298 24.6718L50.3598 2.87183Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
